import './finance-calculator.scss';
import FundingCalculator from './funding-calculator';

const financeCalculator = {
  _shareToFund: {},
  _annualInterest: {},
  _creditExpenses: {},
  _creditPrice: {},
  _monthlyPayment: {},
  _fundingValues: {},
  _language: document.body.classList.contains('fi') ? 'fi' : 'sv', // this defaults to swedish... also, could use ./stage-language.js detection

  init: function() {
    const self = this;
    const financeCalculator = document.getElementById('custom-finance-calculator');

    if (financeCalculator) {
      //Calculator tab menu
      const calculatorTabButtons = document.querySelectorAll('.car-calculator-tab-menu button'),
        calculatorCollasibles = document.querySelectorAll('.car-calculator-collasible');

      for (let i = 0; i < calculatorTabButtons.length; i++) {
        calculatorTabButtons[i].addEventListener('click', function(event) {
          self._toggleCollasible(calculatorTabButtons, calculatorCollasibles, event.target);

          //Scroll to correct position (anchor) on mobile
          if (window.innerWidth <= 1024 && event.target.classList.contains('active')) {
            document.querySelector('a[data-anchor-id="' + event.target.dataset.target + '"]').scrollIntoView();
          }
        });
      }

      //Switch from horizontal tabs to vertical collasibles on mobile, and vice versa
      this._setupCollasibles([calculatorCollasibles]);

      window.addEventListener('resize', function (event) {
        self._setupCollasibles([calculatorCollasibles]);
      });

      //Funding calculator default interest rate selector
      const defaultRateSelector = financeCalculator.getElementsByClassName('select-default-rate')[0],
        interestRateInput = financeCalculator.getElementsByClassName('input-interest-rate')[0],
        defaultRate = interestRateInput.value;

      defaultRateSelector.addEventListener('click', function(event) {
        interestRateInput.value = defaultRate;
        interestRateInput.dispatchEvent(new Event('change'));
      });

      //Funding calculator form change handling
      const fundingCalculatorForm = financeCalculator.getElementsByClassName('finance-calculator-form')[0];
      const opFinanceForm         = document.getElementById('op-financing-form');

      //Output fields to update on calculate
      this._shareToFund = fundingCalculatorForm.querySelector('output[name="share-to-fund"]');
      this._annualInterest = fundingCalculatorForm.querySelector('output[name="annual-interest"]');
      this._creditExpenses = fundingCalculatorForm.querySelector('output[name="credit-expenses"]');
      this._creditPrice = fundingCalculatorForm.querySelector('output[name="credit-price"]');
      this._monthlyPayment = fundingCalculatorForm.querySelector('output[name="monthly-payment"]');

      //Get default values
      this._fundingValues = window.fundingValues;

      //Construct calculator with default values
      FundingCalculator.construct(
        this._fundingValues.deliveryCost,
        this._fundingValues.interestRate,
        this._fundingValues.initialCost,
        this._fundingValues.processingCost
      );

      //Calculate with default values
      this._updateCalculatorOutput(
        FundingCalculator.calculate({
          price: this._fundingValues.price,
          deposit: this._fundingValues.handMoney,
          paymentMonths: this._fundingValues.months,
          lastPayment: this._fundingValues.lastBiggerPayment
        })
      );

      //Select last option of a dynamically generated dropdown list as default value
      const durationSelect = fundingCalculatorForm.querySelector('select[name="contract-duration"]');
      durationSelect.value = durationSelect.options[durationSelect.options.length - 1].value;

      //Handle interest rate change, construct calculator and calculate funding
      fundingCalculatorForm.querySelector('input[name="interest-rate"]').addEventListener('change', function(event) {
        const value = parseFloat(event.target.value);

        if (!(isNaN(value)) && value >= 0) {
          self._fundingValues.interestRate = value;

          FundingCalculator.construct(
            self._fundingValues.deliveryCost,
            self._fundingValues.interestRate,
            self._fundingValues.initialCost,
            self._fundingValues.processingCost
          );

          self._updateCalculatorOutput(
            FundingCalculator.calculate({
              price: self._fundingValues.price,
              deposit: self._fundingValues.handMoney,
              paymentMonths: self._fundingValues.months,
              lastPayment: self._fundingValues.lastBiggerPayment
            })
          );
        }
      });

      //Handle deposit change, calculate funding
      fundingCalculatorForm.querySelector('input[name="deposit"]').addEventListener('change', function(event) {
        const value = parseFloat(event.target.value);

        if (!(isNaN(value)) && value >= 0) {
          self._fundingValues.handMoney = value;

          if(opFinanceForm) opFinanceForm.querySelector('input[name="deposit"]').value = value;

          self._updateCalculatorOutput(
            FundingCalculator.calculate({
              price: self._fundingValues.price,
              deposit: self._fundingValues.handMoney,
              paymentMonths: self._fundingValues.months,
              lastPayment: self._fundingValues.lastBiggerPayment
            })
          );
        }
      });

      //Handle contract duration change, calculate funding
      fundingCalculatorForm.querySelector('select[name="contract-duration"]').addEventListener('change', function(event) {
        const value = parseFloat(event.target.value);

        if (!(isNaN(value)) && value >= 0) {
          self._fundingValues.months = value;

          if(opFinanceForm) opFinanceForm.querySelector('input[name="term_of_payment"]').value = value;

          self._updateCalculatorOutput(
            FundingCalculator.calculate({
              price: self._fundingValues.price,
              deposit: self._fundingValues.handMoney,
              paymentMonths: self._fundingValues.months,
              lastPayment: self._fundingValues.lastBiggerPayment
            })
          );
        }
      });

      //Handle last payment change, calculate funding
      fundingCalculatorForm.querySelector('input[name="last-payment"]').addEventListener('change', function(event) {
        const value = parseFloat(event.target.value);

        if (!(isNaN(value)) && value >= 0) {
          self._fundingValues.lastBiggerPayment = value;

          if(opFinanceForm) opFinanceForm.querySelector('input[name="last_payment"]').value = value;

          self._updateCalculatorOutput(
            FundingCalculator.calculate({
              price: self._fundingValues.price,
              deposit: self._fundingValues.handMoney,
              paymentMonths: self._fundingValues.months,
              lastPayment: self._fundingValues.lastBiggerPayment
            })
          );
        }
      });

      //Handle custom financing amount change, calculate funding
      const customFinancingInput = fundingCalculatorForm.querySelector('input[name="financing"]');

      if (customFinancingInput) {
        customFinancingInput.addEventListener('change', function(event) {
          const value = parseFloat(event.target.value);

          if (!(isNaN(value)) && value > 0) {
            self._fundingValues.price = value;

            self._updateCalculatorOutput(
              FundingCalculator.calculate({
                price: self._fundingValues.price,
                deposit: self._fundingValues.handMoney,
                paymentMonths: self._fundingValues.months,
                lastPayment: self._fundingValues.lastBiggerPayment
              })
            );
          }
        });
      }

      //Pass funding calculator values to request funding offer form when opened
      fundingCalculatorForm.querySelector('button[data-target="request-funding-offer"]').addEventListener('click', function() {
        const fundingForm = document.querySelector('form[name="request-funding-offer"]');

        fundingForm.querySelector('input[name="financing"]').value = self._fundingValues.price;
        fundingForm.querySelector('select[name="contractDuration"]').value = self._fundingValues.months;
        fundingForm.querySelector('input[name="deposit"]').value = self._fundingValues.handMoney;
        fundingForm.querySelector('input[name="lastPayment"]').value = self._fundingValues.lastBiggerPayment;
      });
    }
  },

  _toggleCollasible: function(tabButtons, collasibles, target) {
    for (let i = 0; i < tabButtons.length; i++) {
      if (tabButtons[i] === target && !(tabButtons[i].classList.contains('active'))) {
        tabButtons[i].classList.add('active');
      } else {
        tabButtons[i].classList.remove('active');
      }
    }

    for (let i = 0; i < collasibles.length; i++) {
      if (collasibles[i].dataset.collasibleId === target.dataset.target && !(collasibles[i].classList.contains('show'))) {
        collasibles[i].classList.add('show');
      }
      else {
        collasibles[i].classList.remove('show');
      }
    }
  },

  _setupCollasibles: function(collasiblesArray) {
    for (let j = 0; j < collasiblesArray.length; j++) {
      for (let k = 0; k < collasiblesArray[j].length; k++) {
        if (window.innerWidth <= 1024) {
          const targetCollasible = document.querySelector('[data-target="' + collasiblesArray[j][k].dataset.collasibleId + '"]');

          if (!targetCollasible) {
            continue;
          }

          if (!targetCollasible.parentElement.contains(collasiblesArray[j][k])) {
            targetCollasible.parentElement.appendChild(collasiblesArray[j][k]);
          }
        }
        else {
          const collasibleContainer = document.querySelector('[data-container-id="' + collasiblesArray[j][k].dataset.collasibleId + '"]');

          if (!collasibleContainer.contains(collasiblesArray[j][k])) {
            collasibleContainer.appendChild(collasiblesArray[j][k]);
          }
        }
      }
    }
  },

  _formatValue: function(value) {
    return ((Math.round(parseFloat(value) * 100) / 100).toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ').replace('.', ',').replace(',00', '');
  },

  _updateCalculatorOutput: function(fundingResult) {
    this._shareToFund.innerText = this._formatValue(fundingResult.financedAmount) + ' €';
    this._annualInterest.innerText = this._formatValue(fundingResult.realYearlyInterest) + ' %';
    this._creditExpenses.innerText = this._formatValue(fundingResult.loanExpenses) + ' €';
    this._creditPrice.innerText = this._formatValue(fundingResult.creditPrice) + ' €';
    this._monthlyPayment.innerText = this._formatValue(fundingResult.monthlyTranche) + ' €/' + (this._language === 'fi' ? 'kk' : 'mån.');
  }
};

export default financeCalculator;
